import * as yup from "yup";

const validator = () => {
  return yup.object().shape({});
};

export default validator;
